import { useState } from 'react';

export default function GlobalAffiliatesSection() {
  const [selectedBrand, setSelectedBrand] = useState<any>(null);

  const brands = [
    {
      name: 'Samsung Electronics',
      sector: 'Technology & Electronics',
      description: 'Premium technology and global campaign advertising',
      logo: 'https://public.readdy.ai/ai/img_res/3855fdae935d5172b624fbdd82870efa.jpg',
      caseStudy: {
        title: 'Galaxy S Series Launch Campaign',
        location: 'Dubai Mall & Seoul Gangnam',
        duration: '3 months',
        formats: ['3D LED Display', 'Airport Façade Wrap', 'Highway Mega Billboard'],
        results: [
          { metric: 'Brand Awareness', value: '+285%' },
          { metric: 'Product Inquiries', value: '+420%' },
          { metric: 'Store Visits', value: '+195%' }
        ],
        description: 'Synchronized launch campaign across GCC and Asian markets featuring immersive 3D displays at premium locations. The campaign successfully positioned Samsung as the leading premium smartphone brand in both regions.',
        image: 'https://readdy.ai/api/search-image?query=Samsung%20Galaxy%20smartphone%203D%20billboard%20display%20in%20luxury%20shopping%20mall%2C%20modern%20LED%20advertising%20screen%20with%20premium%20technology%20product%2C%20sophisticated%20retail%20environment%20with%20high-end%20digital%20signage%2C%20contemporary%20urban%20advertising%20installation%20with%20sleek%20design%20and%20perfect%20lighting&width=600&height=400&seq=samsung-campaign-case&orientation=landscape'
      }
    },
    {
      name: 'LG Electronics',
      sector: 'Smart Home & Electronics',
      description: 'Global smart home and electronics product promotion',
      logo: 'https://readdy.ai/api/search-image?query=LG%20Electronics%20official%20corporate%20logo%20on%20clean%20white%20background%2C%20professional%20brand%20identity%2C%20high%20resolution%20company%20logo%2C%20minimalist%20design%20with%20clear%20branding%2C%20corporate%20photography%20with%20perfect%20lighting%20and%20sharp%20details&width=200&height=100&seq=lg-logo-2024&orientation=landscape',
      caseStudy: {
        title: 'OLED TV Innovation Campaign',
        location: 'Tokyo Shibuya & Riyadh Olaya',
        duration: '2 months',
        formats: ['Digital Billboard', 'Mall LED Screen', 'Transit Advertising'],
        results: [
          { metric: 'Product Recognition', value: '+310%' },
          { metric: 'Retail Traffic', value: '+245%' },
          { metric: 'Sales Conversion', value: '+180%' }
        ],
        description: 'Premium OLED TV showcase campaign targeting high-income consumers in major metropolitan areas. Featured stunning visual demonstrations of OLED technology at high-traffic locations.',
        image: 'https://readdy.ai/api/search-image?query=LG%20OLED%20TV%20billboard%20campaign%20in%20modern%20city%20center%2C%20large%20digital%20display%20showing%20premium%20television%20technology%2C%20urban%20advertising%20with%20sophisticated%20design%2C%20contemporary%20cityscape%20with%20high-end%20electronics%20advertising%20and%20perfect%20lighting&width=600&height=400&seq=lg-campaign-case&orientation=landscape'
      }
    },
    {
      name: 'SoftBank',
      sector: 'Investment & Technology',
      description: 'Global investment network and tech brand advertising',
      logo: 'https://readdy.ai/api/search-image?query=SoftBank%20official%20corporate%20logo%20on%20clean%20white%20background%2C%20professional%20brand%20identity%2C%20high%20resolution%20company%20logo%2C%20minimalist%20design%20with%20clear%20branding%2C%20corporate%20photography%20with%20perfect%20lighting%20and%20sharp%20details&width=200&height=100&seq=softbank-logo-2024&orientation=landscape',
      caseStudy: {
        title: 'Vision Fund Brand Campaign',
        location: 'Singapore CBD & Dubai DIFC',
        duration: '4 months',
        formats: ['Premium Office Tower Display', 'Airport Business Lounge', 'Financial District Billboard'],
        results: [
          { metric: 'Brand Perception', value: '+265%' },
          { metric: 'Partnership Inquiries', value: '+340%' },
          { metric: 'Media Coverage', value: '+290%' }
        ],
        description: 'Strategic B2B campaign targeting investors and entrepreneurs in key financial hubs. Positioned SoftBank as the leading technology investment partner in Asia and Middle East.',
        image: 'https://readdy.ai/api/search-image?query=SoftBank%20corporate%20billboard%20in%20financial%20district%2C%20premium%20business%20advertising%20display%20in%20modern%20office%20tower%20area%2C%20sophisticated%20urban%20business%20environment%20with%20professional%20signage%2C%20contemporary%20financial%20hub%20with%20elegant%20corporate%20branding&width=600&height=400&seq=softbank-campaign-case&orientation=landscape'
      }
    },
    {
      name: 'Gucci',
      sector: 'Luxury Fashion',
      description: 'Luxury fashion and lifestyle brand campaigns',
      logo: 'https://readdy.ai/api/search-image?query=Gucci%20official%20luxury%20brand%20logo%20on%20clean%20white%20background%2C%20professional%20brand%20identity%2C%20high%20resolution%20company%20logo%2C%20minimalist%20design%20with%20clear%20branding%2C%20corporate%20photography%20with%20perfect%20lighting%20and%20sharp%20details&width=200&height=100&seq=gucci-logo-2024&orientation=landscape',
      caseStudy: {
        title: 'Fall/Winter Collection Launch',
        location: 'Dubai Mall & Tokyo Omotesando',
        duration: '2 months',
        formats: ['Luxury Mall Façade', '3D Immersive Display', 'Premium Location Billboard'],
        results: [
          { metric: 'Store Footfall', value: '+380%' },
          { metric: 'Collection Sales', value: '+425%' },
          { metric: 'Brand Engagement', value: '+295%' }
        ],
        description: 'Exclusive luxury fashion campaign featuring artistic 3D displays at premium shopping destinations. Created immersive brand experiences that resonated with high-net-worth consumers.',
        image: 'https://readdy.ai/api/search-image?query=Gucci%20luxury%20fashion%20billboard%20in%20premium%20shopping%20district%2C%20elegant%20high-end%20brand%20advertising%20display%2C%20sophisticated%20retail%20district%20with%20luxury%20fashion%20imagery%2C%20contemporary%20upscale%20mall%20with%20artistic%20fashion%20advertising%20and%20perfect%20lighting&width=600&height=400&seq=gucci-campaign-case&orientation=landscape'
      }
    },
    {
      name: 'Polo Ralph Lauren',
      sector: 'Fashion & Lifestyle',
      description: 'Global fashion campaign advertising',
      logo: 'https://readdy.ai/api/search-image?query=Polo%20Ralph%20Lauren%20official%20brand%20logo%20on%20clean%20white%20background%2C%20professional%20brand%20identity%2C%20high%20resolution%20company%20logo%2C%20minimalist%20design%20with%20clear%20branding%2C%20corporate%20photography%20with%20perfect%20lighting%20and%20sharp%20details&width=200&height=100&seq=polo-logo-2024&orientation=landscape',
      caseStudy: {
        title: 'Classic American Style Campaign',
        location: 'Seoul Gangnam & Abu Dhabi Marina',
        duration: '3 months',
        formats: ['Fashion District Billboard', 'Mall Digital Display', 'Lifestyle Hub Advertising'],
        results: [
          { metric: 'Brand Awareness', value: '+270%' },
          { metric: 'Store Traffic', value: '+315%' },
          { metric: 'Product Sales', value: '+225%' }
        ],
        description: 'Lifestyle-focused campaign showcasing timeless American fashion in key Asian and Middle Eastern markets. Successfully attracted younger demographics while maintaining brand heritage.',
        image: 'https://readdy.ai/api/search-image?query=Polo%20Ralph%20Lauren%20fashion%20billboard%20in%20upscale%20shopping%20area%2C%20classic%20American%20style%20brand%20advertising%2C%20sophisticated%20retail%20district%20with%20lifestyle%20fashion%20imagery%2C%20contemporary%20urban%20environment%20with%20elegant%20brand%20display&width=600&height=400&seq=polo-campaign-case&orientation=landscape'
      }
    },
    {
      name: 'Microsoft',
      sector: 'Business Solutions',
      description: 'Enterprise business solution campaigns',
      logo: 'https://readdy.ai/api/search-image?query=Microsoft%20official%20corporate%20logo%20on%20clean%20white%20background%2C%20professional%20brand%20identity%2C%20high%20resolution%20company%20logo%2C%20minimalist%20design%20with%20clear%20branding%2C%20corporate%20photography%20with%20perfect%20lighting%20and%20sharp%20details&width=200&height=100&seq=microsoft-logo-2024&orientation=landscape',
      caseStudy: {
        title: 'Azure Cloud Platform Campaign',
        location: 'Singapore Business District & Riyadh King Abdullah',
        duration: '4 months',
        formats: ['Office Tower Display', 'Tech Hub Billboard', 'Airport Business Terminal'],
        results: [
          { metric: 'Lead Generation', value: '+395%' },
          { metric: 'Enterprise Adoption', value: '+280%' },
          { metric: 'Brand Authority', value: '+320%' }
        ],
        description: 'B2B technology campaign targeting enterprise decision-makers in key business hubs. Positioned Microsoft Azure as the leading cloud platform for digital transformation.',
        image: 'https://readdy.ai/api/search-image?query=Microsoft%20Azure%20cloud%20technology%20billboard%20in%20business%20district%2C%20modern%20corporate%20advertising%20display%20with%20tech%20innovation%20theme%2C%20professional%20office%20environment%20with%20digital%20transformation%20messaging%2C%20contemporary%20business%20hub%20with%20sleek%20technology%20branding&width=600&height=400&seq=microsoft-campaign-case&orientation=landscape'
      }
    },
    {
      name: 'Chanel',
      sector: 'Luxury Beauty & Fashion',
      description: 'Premium cosmetics and fashion advertising',
      logo: 'https://readdy.ai/api/search-image?query=Chanel%20official%20luxury%20brand%20logo%20on%20clean%20white%20background%2C%20professional%20brand%20identity%2C%20high%20resolution%20company%20logo%2C%20minimalist%20design%20with%20clear%20branding%2C%20corporate%20photography%20with%20perfect%20lighting%20and%20sharp%20details&width=200&height=100&seq=chanel-logo-2024&orientation=landscape',
      caseStudy: {
        title: 'No. 5 Perfume Heritage Campaign',
        location: 'Dubai Mall & Osaka Shinsaibashi',
        duration: '2 months',
        formats: ['Luxury Retail Façade', 'Premium Mall Display', 'Airport Duty-Free Zone'],
        results: [
          { metric: 'Product Sales', value: '+445%' },
          { metric: 'Brand Prestige', value: '+365%' },
          { metric: 'Customer Engagement', value: '+290%' }
        ],
        description: 'Iconic perfume campaign celebrating Chanel heritage with elegant displays at ultra-premium locations. Created aspirational brand moments that drove significant sales uplift.',
        image: 'https://readdy.ai/api/search-image?query=Chanel%20No%205%20perfume%20billboard%20in%20luxury%20shopping%20mall%2C%20elegant%20high-end%20beauty%20advertising%20display%2C%20sophisticated%20premium%20retail%20environment%20with%20iconic%20fragrance%20imagery%2C%20contemporary%20upscale%20location%20with%20artistic%20luxury%20branding&width=600&height=400&seq=chanel-campaign-case&orientation=landscape'
      }
    },
    {
      name: "L'Oréal",
      sector: 'Global Beauty',
      description: 'Global beauty brand promotion',
      logo: 'https://readdy.ai/api/search-image?query=L%20Oreal%20official%20corporate%20logo%20on%20clean%20white%20background%2C%20professional%20brand%20identity%2C%20high%20resolution%20company%20logo%2C%20minimalist%20design%20with%20clear%20branding%2C%20corporate%20photography%20with%20perfect%20lighting%20and%20sharp%20details&width=200&height=100&seq=loreal-logo-2024&orientation=landscape',
      caseStudy: {
        title: 'Professional Hair Care Launch',
        location: 'Seoul Myeongdong & Doha City Center',
        duration: '3 months',
        formats: ['Beauty District Billboard', 'Mall Beauty Zone Display', 'Transit Advertising'],
        results: [
          { metric: 'Product Awareness', value: '+355%' },
          { metric: 'Salon Partnerships', value: '+280%' },
          { metric: 'Consumer Trial', value: '+325%' }
        ],
        description: 'Professional beauty campaign targeting both consumers and salon professionals. Successfully established L\'Oréal Professional as the premium choice in both markets.',
        image: 'https://readdy.ai/api/search-image?query=L%20Oreal%20professional%20hair%20care%20billboard%20in%20beauty%20shopping%20district%2C%20modern%20cosmetics%20advertising%20display%20with%20premium%20beauty%20products%2C%20sophisticated%20retail%20environment%20with%20professional%20hair%20care%20imagery%2C%20contemporary%20urban%20location%20with%20elegant%20beauty%20branding&width=600&height=400&seq=loreal-campaign-case&orientation=landscape'
      }
    },
    {
      name: 'Adidas',
      sector: 'Sports & Fashion',
      description: 'Sports and fashion brand campaigns',
      logo: 'https://readdy.ai/api/search-image?query=Adidas%20official%20sports%20brand%20logo%20on%20clean%20white%20background%2C%20professional%20brand%20identity%2C%20high%20resolution%20company%20logo%2C%20minimalist%20design%20with%20clear%20branding%2C%20corporate%20photography%20with%20perfect%20lighting%20and%20sharp%20details&width=200&height=100&seq=adidas-logo-2024&orientation=landscape',
      caseStudy: {
        title: 'Impossible is Nothing Campaign',
        location: 'Tokyo Shibuya & Dubai Sports City',
        duration: '3 months',
        formats: ['Sports Venue Display', 'Youth District Billboard', 'Transit Hub Advertising'],
        results: [
          { metric: 'Youth Engagement', value: '+410%' },
          { metric: 'Product Sales', value: '+385%' },
          { metric: 'Brand Loyalty', value: '+295%' }
        ],
        description: 'Dynamic sports lifestyle campaign targeting active youth demographics. Featured inspiring athlete stories and innovative product showcases at high-energy locations.',
        image: 'https://readdy.ai/api/search-image?query=Adidas%20sports%20billboard%20in%20urban%20youth%20district%2C%20dynamic%20athletic%20brand%20advertising%20display%20with%20sports%20lifestyle%20theme%2C%20energetic%20city%20environment%20with%20active%20lifestyle%20imagery%2C%20contemporary%20urban%20location%20with%20bold%20sports%20branding&width=600&height=400&seq=adidas-campaign-case&orientation=landscape'
      }
    },
    {
      name: 'Coca-Cola',
      sector: 'Beverage & Lifestyle',
      description: 'Global marketing campaigns',
      logo: 'https://readdy.ai/api/search-image?query=Coca%20Cola%20official%20corporate%20logo%20on%20clean%20white%20background%2C%20professional%20brand%20identity%2C%20high%20resolution%20company%20logo%2C%20minimalist%20design%20with%20clear%20branding%2C%20corporate%20photography%20with%20perfect%20lighting%20and%20sharp%20details&width=200&height=100&seq=cocacola-logo-2024&orientation=landscape',
      caseStudy: {
        title: 'Share a Coke Summer Campaign',
        location: 'Seoul City Center & Abu Dhabi Corniche',
        duration: '4 months',
        formats: ['3D Interactive Display', 'Beach Area Billboard', 'Festival Zone Advertising'],
        results: [
          { metric: 'Social Engagement', value: '+520%' },
          { metric: 'Product Sales', value: '+395%' },
          { metric: 'Brand Sentiment', value: '+340%' }
        ],
        description: 'Interactive summer campaign featuring personalized messaging and 3D displays. Created viral social media moments and drove significant sales growth during peak season.',
        image: 'https://readdy.ai/api/search-image?query=Coca%20Cola%20summer%20campaign%20billboard%20in%20city%20center%2C%20vibrant%20beverage%20advertising%20display%20with%20refreshing%20lifestyle%20theme%2C%20energetic%20urban%20environment%20with%20colorful%20brand%20imagery%2C%20contemporary%20location%20with%20dynamic%20consumer%20brand%20display&width=600&height=400&seq=cocacola-campaign-case&orientation=landscape'
      }
    },
    {
      name: 'Toyota',
      sector: 'Automotive Innovation',
      description: 'Innovative mobility advertising',
      logo: 'https://readdy.ai/api/search-image?query=Toyota%20official%20automotive%20brand%20logo%20on%20clean%20white%20background%2C%20professional%20brand%20identity%2C%20high%20resolution%20company%20logo%2C%20minimalist%20design%20with%20clear%20branding%2C%20corporate%20photography%20with%20perfect%20lighting%20and%20sharp%20details&width=200&height=100&seq=toyota-logo-2024&orientation=landscape',
      caseStudy: {
        title: 'Hybrid Technology Leadership Campaign',
        location: 'Riyadh King Fahd Road & Tokyo Bay Area',
        duration: '3 months',
        formats: ['Highway Mega Billboard', 'Auto Show Display', 'Airport Approach Advertising'],
        results: [
          { metric: 'Dealer Inquiries', value: '+365%' },
          { metric: 'Test Drives', value: '+420%' },
          { metric: 'Sales Conversion', value: '+285%' }
        ],
        description: 'Sustainability-focused automotive campaign highlighting Toyota\'s hybrid technology leadership. Successfully positioned Toyota as the eco-friendly choice for modern drivers.',
        image: 'https://readdy.ai/api/search-image?query=Toyota%20hybrid%20car%20billboard%20on%20major%20highway%2C%20modern%20automotive%20advertising%20display%20with%20eco-friendly%20vehicle%20technology%2C%20wide%20urban%20expressway%20with%20premium%20car%20imagery%2C%20contemporary%20transportation%20hub%20with%20innovative%20automotive%20branding&width=600&height=400&seq=toyota-campaign-case&orientation=landscape'
      }
    },
    {
      name: 'Starbucks',
      sector: 'Food & Beverage',
      description: 'Global brand promotion',
      logo: 'https://readdy.ai/api/search-image?query=Starbucks%20official%20corporate%20logo%20on%20clean%20white%20background%2C%20professional%20brand%20identity%2C%20high%20resolution%20company%20logo%2C%20minimalist%20design%20with%20clear%20branding%2C%20corporate%20photography%20with%20perfect%20lighting%20and%20sharp%20details&width=200&height=100&seq=starbucks-logo-2024&orientation=landscape',
      caseStudy: {
        title: 'Reserve Roastery Launch Campaign',
        location: 'Seoul Gangnam & Dubai Downtown',
        duration: '2 months',
        formats: ['Premium District Billboard', 'Mall Food Court Display', 'Business District Advertising'],
        results: [
          { metric: 'Store Visits', value: '+485%' },
          { metric: 'Premium Sales', value: '+395%' },
          { metric: 'Brand Perception', value: '+315%' }
        ],
        description: 'Premium coffee experience campaign targeting affluent urban professionals. Successfully elevated Starbucks brand positioning in both markets.',
        image: 'https://readdy.ai/api/search-image?query=Starbucks%20Reserve%20coffee%20billboard%20in%20premium%20urban%20district%2C%20sophisticated%20cafe%20brand%20advertising%20display%20with%20artisan%20coffee%20theme%2C%20upscale%20city%20environment%20with%20premium%20beverage%20imagery%2C%20contemporary%20business%20area%20with%20elegant%20coffee%20culture%20branding&width=600&height=400&seq=starbucks-campaign-case&orientation=landscape'
      }
    },
    {
      name: 'Dior',
      sector: 'Premium Beauty & Fashion',
      description: 'Premium beauty and fashion campaigns',
      logo: 'https://readdy.ai/api/search-image?query=Dior%20official%20luxury%20brand%20logo%20on%20clean%20white%20background%2C%20professional%20brand%20identity%2C%20high%20resolution%20company%20logo%2C%20minimalist%20design%20with%20clear%20branding%2C%20corporate%20photography%20with%20perfect%20lighting%20and%20sharp%20details&width=200&height=100&seq=dior-logo-2024&orientation=landscape',
      caseStudy: {
        title: 'Haute Couture Collection Campaign',
        location: 'Tokyo Ginza & Dubai Mall Fashion Avenue',
        duration: '2 months',
        formats: ['Luxury Façade Wrap', 'Premium Mall Display', 'Fashion Week Venue'],
        results: [
          { metric: 'VIP Appointments', value: '+455%' },
          { metric: 'Collection Sales', value: '+520%' },
          { metric: 'Brand Exclusivity', value: '+385%' }
        ],
        description: 'Ultra-luxury fashion campaign targeting UHNW individuals. Created exclusive brand experiences that reinforced Dior\'s position as the pinnacle of haute couture.',
        image: 'https://readdy.ai/api/search-image?query=Dior%20haute%20couture%20billboard%20in%20luxury%20fashion%20district%2C%20elegant%20high-end%20fashion%20advertising%20display%20with%20artistic%20couture%20imagery%2C%20sophisticated%20premium%20retail%20environment%2C%20contemporary%20upscale%20location%20with%20exquisite%20luxury%20fashion%20branding&width=600&height=400&seq=dior-campaign-case&orientation=landscape'
      }
    },
    {
      name: 'Mercedes-Benz',
      sector: 'Luxury Automotive',
      description: 'Luxury automobile brand advertising',
      logo: 'https://readdy.ai/api/search-image?query=Mercedes%20Benz%20official%20luxury%20automotive%20logo%20on%20clean%20white%20background%2C%20professional%20brand%20identity%2C%20high%20resolution%20company%20logo%2C%20minimalist%20design%20with%20clear%20branding%2C%20corporate%20photography%20with%20perfect%20lighting%20and%20sharp%20details&width=200&height=100&seq=mercedes-logo-2024&orientation=landscape',
      caseStudy: {
        title: 'EQ Electric Luxury Campaign',
        location: 'Singapore Marina Bay & Doha West Bay',
        duration: '3 months',
        formats: ['Premium Highway Billboard', 'Luxury Hotel Display', 'Airport VIP Terminal'],
        results: [
          { metric: 'Showroom Visits', value: '+390%' },
          { metric: 'Pre-Orders', value: '+445%' },
          { metric: 'Brand Prestige', value: '+355%' }
        ],
        description: 'Electric luxury vehicle campaign targeting environmentally-conscious affluent consumers. Successfully positioned Mercedes-Benz EQ as the ultimate electric luxury choice.',
        image: 'https://readdy.ai/api/search-image?query=Mercedes%20Benz%20EQ%20electric%20car%20billboard%20in%20luxury%20district%2C%20premium%20automotive%20advertising%20display%20with%20sophisticated%20electric%20vehicle%2C%20upscale%20urban%20environment%20with%20elegant%20luxury%20car%20imagery%2C%20contemporary%20high-end%20location%20with%20refined%20automotive%20branding&width=600&height=400&seq=mercedes-campaign-case&orientation=landscape'
      }
    },
    {
      name: 'Nike',
      sector: 'Sports & Lifestyle',
      description: 'Global sports campaigns',
      logo: 'https://readdy.ai/api/search-image?query=Nike%20official%20sports%20brand%20logo%20on%20clean%20white%20background%2C%20professional%20brand%20identity%2C%20high%20resolution%20company%20logo%2C%20minimalist%20design%20with%20clear%20branding%2C%20corporate%20photography%20with%20perfect%20lighting%20and%20sharp%20details&width=200&height=100&seq=nike-logo-2024&orientation=landscape',
      caseStudy: {
        title: 'Just Do It Global Campaign',
        location: 'Seoul Olympic Park & Dubai Sports Hub',
        duration: '4 months',
        formats: ['Sports Venue Wrap', 'Youth District Billboard', 'Fitness Center Display'],
        results: [
          { metric: 'Brand Engagement', value: '+495%' },
          { metric: 'Product Sales', value: '+425%' },
          { metric: 'App Downloads', value: '+380%' }
        ],
        description: 'Inspirational sports campaign featuring local athletes and global icons. Created powerful brand connections with active lifestyle consumers across both regions.',
        image: 'https://readdy.ai/api/search-image?query=Nike%20Just%20Do%20It%20billboard%20in%20sports%20district%2C%20powerful%20athletic%20brand%20advertising%20display%20with%20inspirational%20sports%20theme%2C%20dynamic%20urban%20environment%20with%20motivational%20athlete%20imagery%2C%20contemporary%20active%20lifestyle%20location%20with%20bold%20sports%20branding&width=600&height=400&seq=nike-campaign-case&orientation=landscape'
      }
    }
  ];

  const sectors = [
    {
      icon: 'ri-smartphone-line',
      name: 'Technology & Electronics',
      count: 3,
      color: 'bg-blue-100 text-blue-600'
    },
    {
      icon: 'ri-shirt-line',
      name: 'Fashion & Luxury',
      count: 5,
      color: 'bg-purple-100 text-purple-600'
    },
    {
      icon: 'ri-car-line',
      name: 'Automotive',
      count: 2,
      color: 'bg-red-100 text-red-600'
    },
    {
      icon: 'ri-shopping-bag-line',
      name: 'Beauty & Cosmetics',
      count: 2,
      color: 'bg-pink-100 text-pink-600'
    },
    {
      icon: 'ri-cup-line',
      name: 'Food & Beverage',
      count: 2,
      color: 'bg-green-100 text-green-600'
    },
    {
      icon: 'ri-global-line',
      name: 'Business Solutions',
      count: 1,
      color: 'bg-indigo-100 text-indigo-600'
    }
  ];

  return (
    <section className="py-12 sm:py-16 lg:py-20 xl:py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-8 sm:mb-12 lg:mb-16">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-light text-gray-900 mb-3 sm:mb-4 lg:mb-6">
            🌍 Global Affiliates
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-gray-600 font-light max-w-4xl mx-auto leading-relaxed">
            Trusted by world-leading brands, DHB Group's advertising platform connects global brands with local markets. 
            We go beyond traditional advertising to serve as a media gateway that bridges brand value with market success.
          </p>
        </div>

        {/* Industry Sectors */}
        <div className="mb-8 sm:mb-12 lg:mb-16">
          <h3 className="text-xl sm:text-2xl lg:text-3xl font-light text-gray-900 mb-4 sm:mb-6 lg:mb-8 text-center">
            Industry Sectors We Serve
          </h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-4 lg:gap-6">
            {sectors.map((sector, index) => (
              <div key={index} className="bg-white rounded-xl p-3 sm:p-4 lg:p-6 shadow-sm hover:shadow-md transition-shadow text-center">
                <div className={`w-10 h-10 sm:w-12 sm:h-12 lg:w-16 lg:h-16 ${sector.color} rounded-full flex items-center justify-center mx-auto mb-2 sm:mb-3`}>
                  <i className={`${sector.icon} text-lg sm:text-xl lg:text-2xl`}></i>
                </div>
                <h4 className="text-xs sm:text-sm lg:text-base font-medium text-gray-900 mb-1">
                  {sector.name}
                </h4>
                <p className="text-xs sm:text-sm text-gray-500">
                  {sector.count} {sector.count === 1 ? 'Brand' : 'Brands'}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Trust Statement */}
        <div className="bg-gradient-to-r from-blue-600 to-indigo-600 rounded-xl sm:rounded-2xl p-6 sm:p-8 lg:p-12 mb-8 sm:mb-12 lg:mb-16 text-center">
          <h3 className="text-xl sm:text-2xl lg:text-3xl font-light text-white mb-3 sm:mb-4 lg:mb-6">
            Trusted by Global Leaders
          </h3>
          <p className="text-sm sm:text-base lg:text-lg text-white/90 font-light max-w-3xl mx-auto leading-relaxed">
            From Samsung and Microsoft to Gucci and Chanel, the world's most recognized brands choose DHB Group 
            to deliver powerful messages to global consumers and enhance their market competitiveness.
          </p>
        </div>

        {/* Brand Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 sm:gap-6 lg:gap-8 mb-8 sm:mb-12 lg:mb-16">
          {brands.map((brand, index) => (
            <div 
              key={index} 
              onClick={() => setSelectedBrand(brand)}
              className="bg-white rounded-xl p-4 sm:p-6 shadow-sm hover:shadow-md transition-all hover:-translate-y-1 cursor-pointer"
            >
              <div className="aspect-video bg-gray-50 rounded-lg mb-3 sm:mb-4 flex items-center justify-center overflow-hidden">
                <img 
                  src={brand.logo} 
                  alt={`${brand.name} logo`}
                  className="w-full h-full object-contain p-2 sm:p-3"
                />
              </div>
              <h4 className="text-xs sm:text-sm lg:text-base font-medium text-gray-900 mb-1 sm:mb-2">
                {brand.name}
              </h4>
              <p className="text-xs text-blue-600 font-medium mb-1 sm:mb-2">
                {brand.sector}
              </p>
              <p className="text-xs text-gray-600 font-light leading-relaxed">
                {brand.description}
              </p>
            </div>
          ))}
        </div>

        {/* Statistics */}
        <div className="bg-white rounded-xl sm:rounded-2xl p-6 sm:p-8 lg:p-12 shadow-sm mb-8 sm:mb-12 lg:mb-16">
          <h3 className="text-xl sm:text-2xl lg:text-3xl font-light text-gray-900 mb-6 sm:mb-8 lg:mb-12 text-center">
            Partnership Impact
          </h3>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-8">
            <div className="text-center">
              <div className="text-2xl sm:text-3xl lg:text-4xl font-light text-blue-600 mb-1 sm:mb-2">15+</div>
              <div className="text-xs sm:text-sm lg:text-base text-gray-600 font-light">Global Brands</div>
            </div>
            <div className="text-center">
              <div className="text-2xl sm:text-3xl lg:text-4xl font-light text-blue-600 mb-1 sm:mb-2">6</div>
              <div className="text-xs sm:text-sm lg:text-base text-gray-600 font-light">Industry Sectors</div>
            </div>
            <div className="text-center">
              <div className="text-2xl sm:text-3xl lg:text-4xl font-light text-blue-600 mb-1 sm:mb-2">50+</div>
              <div className="text-xs sm:text-sm lg:text-base text-gray-600 font-light">Countries Reached</div>
            </div>
            <div className="text-center">
              <div className="text-2xl sm:text-3xl lg:text-4xl font-light text-blue-600 mb-1 sm:mb-2">98%</div>
              <div className="text-xs sm:text-sm lg:text-base text-gray-600 font-light">Client Satisfaction</div>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="text-center">
          <h3 className="text-xl sm:text-2xl lg:text-3xl font-light text-gray-900 mb-3 sm:mb-4 lg:mb-6">
            Join the World's Leading Brands
          </h3>
          <p className="text-sm sm:text-base lg:text-lg text-gray-600 font-light mb-4 sm:mb-6 lg:mb-8 max-w-3xl mx-auto">
            Partner with DHB Group to elevate your brand's global presence and connect with audiences across key markets worldwide
          </p>
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
            <button 
              onClick={() => {
                if (window.REACT_APP_NAVIGATE) {
                  window.REACT_APP_NAVIGATE('/portal');
                }
              }}
              className="bg-blue-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg hover:bg-blue-700 transition-colors font-medium text-sm sm:text-base lg:text-lg whitespace-nowrap cursor-pointer"
            >
              Become a Partner
            </button>
            <button 
              onClick={() => {
                const contactSection = document.getElementById('contact');
                if (contactSection) {
                  contactSection.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="border border-blue-600 text-blue-600 px-6 sm:px-8 py-3 sm:py-4 rounded-lg hover:bg-blue-50 transition-colors font-medium text-sm sm:text-base lg:text-lg whitespace-nowrap cursor-pointer"
            >
              Contact Our Team
            </button>
          </div>
        </div>
      </div>

      {/* Case Study Modal */}
      {selectedBrand && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 sm:p-6 z-50" onClick={() => setSelectedBrand(null)}>
          <div className="bg-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            {/* Modal Header */}
            <div className="sticky top-0 bg-white border-b border-gray-200 p-4 sm:p-6 flex justify-between items-center">
              <div className="flex items-center gap-3 sm:gap-4">
                <div className="w-12 h-12 sm:w-16 sm:h-16 bg-gray-50 rounded-lg flex items-center justify-center p-2">
                  <img src={selectedBrand.logo} alt={selectedBrand.name} className="w-full h-full object-contain" />
                </div>
                <div>
                  <h3 className="text-lg sm:text-xl font-semibold text-gray-900">{selectedBrand.name}</h3>
                  <p className="text-xs sm:text-sm text-blue-600">{selectedBrand.sector}</p>
                </div>
              </div>
              <button 
                onClick={() => setSelectedBrand(null)}
                className="text-gray-400 hover:text-gray-600 text-2xl sm:text-3xl cursor-pointer w-8 h-8 flex items-center justify-center"
              >
                ×
              </button>
            </div>

            {/* Modal Content */}
            <div className="p-4 sm:p-6 lg:p-8">
              {/* Campaign Image */}
              <div className="mb-6 sm:mb-8">
                <img 
                  src={selectedBrand.caseStudy.image} 
                  alt={selectedBrand.caseStudy.title}
                  className="w-full h-48 sm:h-64 lg:h-80 object-cover object-top rounded-xl"
                />
              </div>

              {/* Campaign Title */}
              <h4 className="text-xl sm:text-2xl lg:text-3xl font-semibold text-gray-900 mb-3 sm:mb-4">
                {selectedBrand.caseStudy.title}
              </h4>

              {/* Campaign Details */}
              <div className="grid grid-cols-2 gap-3 sm:gap-4 mb-6 sm:mb-8">
                <div className="bg-gray-50 rounded-lg p-3 sm:p-4">
                  <div className="flex items-center gap-2 mb-1 sm:mb-2">
                    <i className="ri-map-pin-line text-blue-600 text-base sm:text-lg"></i>
                    <span className="text-xs sm:text-sm text-gray-600 font-medium">Location</span>
                  </div>
                  <p className="text-sm sm:text-base text-gray-900 font-medium">{selectedBrand.caseStudy.location}</p>
                </div>
                <div className="bg-gray-50 rounded-lg p-3 sm:p-4">
                  <div className="flex items-center gap-2 mb-1 sm:mb-2">
                    <i className="ri-calendar-line text-blue-600 text-base sm:text-lg"></i>
                    <span className="text-xs sm:text-sm text-gray-600 font-medium">Duration</span>
                  </div>
                  <p className="text-sm sm:text-base text-gray-900 font-medium">{selectedBrand.caseStudy.duration}</p>
                </div>
              </div>

              {/* Ad Formats */}
              <div className="mb-6 sm:mb-8">
                <h5 className="text-base sm:text-lg font-semibold text-gray-900 mb-3 sm:mb-4">Campaign Formats</h5>
                <div className="flex flex-wrap gap-2">
                  {selectedBrand.caseStudy.formats.map((format: string, idx: number) => (
                    <span key={idx} className="bg-blue-100 text-blue-700 px-3 py-1.5 rounded-full text-xs sm:text-sm font-medium">
                      {format}
                    </span>
                  ))}
                </div>
              </div>

              {/* Results */}
              <div className="mb-6 sm:mb-8">
                <h5 className="text-base sm:text-lg font-semibold text-gray-900 mb-3 sm:mb-4">Campaign Results</h5>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4">
                  {selectedBrand.caseStudy.results.map((result: any, idx: number) => (
                    <div key={idx} className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-lg p-4 text-center">
                      <div className="text-2xl sm:text-3xl font-bold text-green-600 mb-1 sm:mb-2">{result.value}</div>
                      <div className="text-xs sm:text-sm text-gray-700 font-medium">{result.metric}</div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Description */}
              <div className="mb-6 sm:mb-8">
                <h5 className="text-base sm:text-lg font-semibold text-gray-900 mb-3 sm:mb-4">Campaign Overview</h5>
                <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                  {selectedBrand.caseStudy.description}
                </p>
              </div>

              {/* CTA */}
              <div className="bg-blue-50 rounded-xl p-4 sm:p-6 text-center">
                <h5 className="text-base sm:text-lg font-semibold text-gray-900 mb-2 sm:mb-3">
                  Ready to achieve similar results?
                </h5>
                <p className="text-xs sm:text-sm text-gray-600 mb-4">
                  Let's create a winning campaign strategy for your brand
                </p>
                <button 
                  onClick={() => {
                    setSelectedBrand(null);
                    if (window.REACT_APP_NAVIGATE) {
                      window.REACT_APP_NAVIGATE('/portal?modal=consultation');
                    }
                  }}
                  className="bg-blue-600 text-white px-6 sm:px-8 py-3 rounded-lg hover:bg-blue-700 transition-colors font-medium text-sm sm:text-base whitespace-nowrap cursor-pointer"
                >
                  Schedule Free Consultation
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
